import request from '@/utils/request'

// 重新人脸核验
export function needFaceVerify(params: Record<string, any>) {
    return request.post({
        url: '/verification/needFaceVerify',
        params
    })
}

// 营业执照识别
export function licenseIdentify(params: Record<string, any>) {
    return request.post({
        url: '/verification/licenseIdentify',
        params
    })
}

// 身份证识别
export function idCardPhoto(params: Record<string, any>) {
    return request.post({
        url: '/verification/idCardPhoto',
        params
    })
}

// 提交核验
export function commit(params: Record<string, any>) {
    return request.post({
        url: '/verification/commit',
        params
    })
}

// 查询认证结果(阿里云)
export function certifyResponse(params: Record<string, any>) {
    return request.post({
        url: '/verification/certifyResponse',
        params
    })
}

// 调整图片
export function adjustImage(params: Record<string, any>) {
    return request.post({
        url: '/verification/adjustImage',
        params
    })
}

// 实人认证初始化(聚美)
export function initCertifyJm(params: Record<string, any>) {
    return request.post({
        url: '/verification/initCertifyJm',
        params
    })
}

// 查询认证结果(聚美)
export function certifyJmResponse(params: Record<string, any>) {
    return request.post({
        url: '/verification/certifyJmResponse',
        params
    })
}

// 身份证对比人脸(聚美)
export function faceComparison(params: Record<string, any>) {
    return request.post({
        url: '/verification/faceComparison',
        params
    })
}

// 营业执照核验-企业三要素
export function companyDocumentCheck(params: Record<string, any>) {
    return request.post({
        url: '/verification/companyDocumentCheck',
        params
    })
}

// 旋转图片
export function rotate(params: Record<string, any>) {
    return request.post({
        url: '/verification/rotate',
        params
    })
}

// 判断当前主体是否需要人脸核验
export function checkFace(params: Record<string, any>) {
    return request.post({
        url: '/verification/checkFace',
        params
    })
}

// 获取主体证件信息
export function getMainFile(params: Record<string, any>) {
    return request.post({
        url: '/verification/getMainFile',
        params
    })
}

// 保存主体证件
export function saveMainFile(params: Record<string, any>) {
    return request.post({
        url: '/verification/saveMainFile',
        params
    })
}

// 实人认证初始化(一砂)
export function faceComparisonVideoInit(params: Record<string, any>) {
    return request.post({
        url: '/verification/faceComparisonVideo',
        params
    })
}

// 查询认证结果(一砂)
export function certificationResult(params: Record<string, any>) {
    return request.post({
        url: '/verification/certificationResult',
        params
    })
}

// 保存主体身份证
export function saveMainFileIdentityCard(params: Record<string, any>) {
    return request.post({
        url: '/verification/saveMainFileIdentityCard',
        params
    })
}

// 保存合成身份证
export function saveIdCard(params: Record<string, any>) {
    return request.post({
        url: '/verification/saveIdCard',
        params
    })
}

// 部平台鉴权测试
export function gxbAuthTest() {
    return request.post({ url: '/verification/gxbAuthTest' })
}

// 生成/刷新部平台二维码
export function gxbSaveQrcode(params: Record<string, any>) {
    return request.post({ url: '/verification/gxbSaveQrcode', params })
}

// 同步部平台核验材料
export function gxbSync(params: Record<string, any>) {
    return request.post({ url: '/verification/gxbSync', params })
}

// 同步部平台核验材料（不弹单条成功/失败提示，供批量循环）
export function gxbSyncQuiet(params: Record<string, any>) {
    return request.post(
        { url: '/verification/gxbSync', params },
        { isTransformResponse: false, ignoreCancelToken: true }
    )
}

// 部平台重新核验
export function gxbReverify(params: Record<string, any>) {
    return request.post({ url: '/verification/gxbReverify', params })
}

// 重置部平台核验次数
export function gxbRecount(params: Record<string, any>) {
    return request.post({ url: '/verification/gxbRecount', params })
}
